import { formatText } from 'core/i18n';
import React from 'react';

export const DocumentsModalFooter = ({
    areAlldocumentsAccepted,
    isCurrentDocumentAcepted,
    isCurrentDocumentRead,
    onClose,
    onCancel,
    onConfirm,
    onContinue,
    onAcceptAndContinue,
    onContinueDisabled,
}) => {
    const getPrimaryButtonContent = () => {
        if (areAlldocumentsAccepted) return formatText('button-understood');
        if (isCurrentDocumentAcepted) return formatText('button-readNextPendingDocument');

        return formatText('button-acceptAndContinue');
    };

    const handleClickPrimaryButton = event => {
        if (areAlldocumentsAccepted) return onConfirm(event);
        if (isCurrentDocumentAcepted) return onContinue(event);
        onAcceptAndContinue(event);
    };
    const returnButtonTextKey = isCurrentDocumentRead || isCurrentDocumentAcepted ? 'button-close' : 'button-goBack';
    const handleReturnButtonClick = isCurrentDocumentAcepted ? onClose : onCancel;

    return (
        <div className="documents__modal-buttons">
            <span>
                <button onClick={handleReturnButtonClick}>
                    <p aria-label="close-btn">{formatText(returnButtonTextKey)}</p>
                </button>
            </span>
            {isCurrentDocumentRead ? (
                <button
                    className="form__button form__button-secondary"
                    onClick={handleClickPrimaryButton}
                    aria-label="confirm-btn"
                >
                    {getPrimaryButtonContent()}
                </button>
            ) : (
                <button className="form__button  disable-styles" onClick={onContinueDisabled} aria-label="confirm-btn">
                    {getPrimaryButtonContent()}
                </button>
            )}
        </div>
    );
};
